import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const HazardousWarningTitle = styled(Box).attrs(({ theme }) => ({
  py: 12,
  px: 16,
  bg: theme.colors.trainIncidentAlert.iconBg,
  borderRadius: 5,
  color: theme.colors.trainIncidentAlert.iconColor,
  horizontal: true,
  flow: 8,
  align: 'center',
}))``;
